import Home from '../views/Home.vue'
export default {
  path: '/learn',
  name: '学习园地',
  component: Home,
  iconCls: 'el-icon-user-solid',
  roles: ['AppUser'],
  hidden: false,
  children: [
    {
      path: '/learn',
      component: () =>
                import('../views/learn/indexOut'),
      name: '学习园地',
      roles: ['AppUser'],
      hidden: true
    },
    {
      path: '/learn/index',
      component: () =>
                import('../views/learn/index'),
      name: '学习园地列表',
      roles: ['AppUser'],
      hidden: true
    }
    // {
    //   path: '/library/contrast/details',
    //   component: () =>
    //             import('../views/library/details/comContrast/details/index.vue'),
    //   name: '评比详情',
    //   roles: ['AppUser'],
    //   hidden: true
    // }
  ]
}
